// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.modal-collective-members[data-v-29a7a577]{height:550px;max-height:80vh;padding-bottom:12px}`, "",{"version":3,"sources":["webpack://./src/components/Nav/CollectiveMembersModal.vue"],"names":[],"mappings":"AACA,2CACC,YAAA,CACA,eAAA,CACA,mBAAA","sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
